// Method copied from Portal Player.
// https://github.com/groupflix/portal-player/blob/master/players/js/panel.templates.js#L4370
export const getEmojiIcon = (emojiCode) => {
	let icon = '';

	switch (emojiCode) {
		case 'a':
			icon = "❤️";
			break;
		case 'b':
			icon = "😊";
			break;
		case 'c':
			icon = "🔥";
			break;
		case 'd':
			icon = "😂";
			break;
		case 'e':
			icon = "😱";
			break;
		case 'f':
			icon = "🎯";
			break;
		case 'g':
			icon = "😮";
			break;
		case 'h':
			icon = "😬";
			break;
		case 'i':
			icon = "💎";
			break;
		case 'j':
			icon = "🤯";
			break;
		case 'k':
			icon = "💋";
			break;
		case 'l':
			icon = "🌟";
			break;
		case 'm':
			icon = "😨";
			break;
		case 'n':
			icon = "🤝";
			break;
		case 'o':
			icon = "🚀";
			break;
		case 'p':
			icon = "😕";
			break;
		case 'q':
			icon = "😢";
			break;
		case 'r':
			icon = "😡";
			break;
		case 's':
			icon = "😬";
			break;
		case 't':
			icon = "👍🏼";
			break;
		case 'u':
			icon = "🥱";
			break;
		case 'v':
			icon = "❓";
			break;
		case 'w':
			icon = "😳";
			break;
		case 'x':
			icon = "🥴";
			break;
		case 'y':
			icon = "🙄";
			break;
		case 'z':
			icon = "👀";
			break;
	}

	return icon;
};


// WEBPACK FOOTER //
// ./src/functions/emotion.js